// Main application entry point
// This replaces both the sprockets manifest and webpack pack

import $ from "jquery";

// jQuery and jQuery UI need to be available globally for legacy code
// jQuery is injected globally via jquery-shim.js in esbuild config
// Import complete jQuery UI bundle
import "jquery-ui/dist/jquery-ui";

// Rails UJS replacement - using @rails/ujs instead of jquery_ujs
import Rails from "@rails/ujs";
Rails.start();

// Vendor libraries
import "./vendor/jquery.tablesorter.min";
import "./vendor/jquery.tablesorter.widgets";
import "./vendor/typeahead.bundle";

// Bootstrap JavaScript
import "bootstrap";

// Rails libraries
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "./channels/index";

// Application modules (in dependency order)
import "./custom";
import "./alerts";
import "./campaigns";
import "./entities";
import "./transactions";
import "./approve_transactions";
import "./bulk_approval";
import "./bulk_edit";
import "./batch_modal";
import "./campaign_index";
import "./contribution_limits";
import "./direct_upload";
import "./merge_entities";
import "./confirm_entity_comparison";
import "./campaign_onboarding";

// Stimulus controllers
import "./controllers";

// Initialize ActiveStorage
ActiveStorage.start();
